import { render, staticRenderFns } from "./carrier.vue?vue&type=template&id=ff88cb52&"
import script from "./carrier.vue?vue&type=script&lang=js&"
export * from "./carrier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports